module.exports = __webpack_public_path__ + "img/create_account.ba8b6113.jpg";